<div mat-dialog-title>
  {{ 'Select Investigators' | translate}}
</div>

<div mat-dialog-content>
  <div fxLayout="column" fxLayoutGap="0.5vw">
    <mat-form-field fxFlex *ngIf="!caseId">
      <mat-select [placeholder]="'Select Case' | translate" [(ngModel)]="caseId"
        (ngModelChange)="getInvestigators(caseId)">
        <mat-option *ngFor="let case of cases" [value]="case._id">
          {{ case.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field fxFlex style="width: 100%;">
      <mat-select [placeholder]="'Select Investigators' | translate" multiple [(ngModel)]="investigatorIds"
        [disabled]="investigators.length == 0 || loading">
        <mat-select-trigger>
          {{ getSelectedInvestigatorsText() }}
        </mat-select-trigger>
        <div class="search-container">
          <input [placeholder]="'Search' | translate" [(ngModel)]="investigatorSearch"
            (keydown)="$event.stopPropagation()">
        </div>
        <mat-option *ngFor="let investigator of filteredInvestigators" [value]="investigator._id"
          class="investigator-option">
          <div class="name-line">{{ investigator.alternative_name || investigator.name }}</div>
          <div class="info-line">
            <span *ngIf="investigator.rank">{{ investigator.rank | enum: ranksEnum}}</span>
            <span *ngIf="investigator.rank && investigator.distance && investigator.distanceInKm > 0"> • </span>
            <span *ngIf="investigator.distance && investigator.distance > 0">{{investigator.distance}}
              {{distanceUnit | translate}}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div fxFlex *ngIf="dispatched">
      <mat-checkbox name="excludeFromMap" color="primary" [(ngModel)]="excludeFromMap"
        class="exclude-from-map-checkbox">
        {{ 'Exclude from map' | translate }}
      </mat-checkbox>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button *ngIf="dummyThreat" mat-raised-button class="green-text" (click)="createThreat('dispatch')"
    [disabled]="!caseId || investigatorIds.length == 0 || loading">{{ 'Dispatch' | translate
    }}</button>
  <button *ngIf="!dummyThreat" mat-raised-button class="green-text" (click)="dispatch()"
    [disabled]="!caseId || investigatorIds.length == 0 || loading">{{ (dispatched
    ? 'Re-Dispatch' : 'Dispatch') | translate
    }}</button>
  <button mat-raised-button class="green-text" (click)="createThreat('threat-management-center')"
    *ngIf="showThreatManagementCenter" [disabled]="loading">
    {{ 'View in Incident Management Center' | translate }}
    <!-- <mat-icon class="mat-icon-alone" iconPositionEnd>chevron_right</mat-icon> -->
  </button>
  <button mat-raised-button class="red-text" *ngIf="!dispatched" (click)="closeDialog(undefined)">{{ 'Cancel' |
    translate }}</button>
  <button mat-raised-button class="red-text" *ngIf="dispatched" (click)="closeDialog(undefined)">{{ 'Close' | translate
    }}</button>
</div>